export default "__VITE_ASSET__Bj36_2Id__"